export function buildArticleAuthor(articleAuthor: any) {
  const author = articleAuthor?.expandedValue
  const name = author?.name

  if (!name)
    return undefined

  const url = author?.authorProfileUrl?.value
  const sameAs = (author?.authorSocialLinks?.value ?? [])
    .map((link: any) => link?.href)
    .filter((href: any) => typeof href === 'string' && href.trim().length > 0)

  return {
    '@type': 'Person',
    'name': name,
    ...(url ? { url } : {}),
    ...(sameAs.length ? { sameAs } : {}),
  }
}
